import { FormikField } from '@air/formik-field';
import { type InputProps } from '@air/primitive-input';

import { PasswordInputWithVisibilityToggle } from '~/components/Form/PasswordInputWithVisibilityToggle';

type PasswordInputProps = {
  label?: string;
  name?: string;
  testId?: string;
  className?: string;
  description?: string;
} & Partial<Pick<InputProps, 'disabled' | 'size'>>;

const PasswordInput = ({ className, testId, label, name, disabled, size, description }: PasswordInputProps) => {
  const fieldName = name || 'password';

  return (
    <FormikField
      id={fieldName}
      className={className}
      label={label || 'Password *'}
      description={description}
      component={
        <PasswordInputWithVisibilityToggle
          autoComplete="new-password"
          disabled={disabled}
          data-testid={testId}
          size={size}
        />
      }
      name={fieldName}
    />
  );
};

export default PasswordInput;
